import { ref } from 'vue';
import type { StoreConfiguration } from '../types/storeConfig';
import { dataFetch } from './helpers/dataFetch';

const configData = ref<StoreConfiguration>();
const eTagLocalStore = 'store-config-eTag';
const storeId = 'store-configuration';
const storeLocale = 'store-locale';
const storeLanguage = 'store-language';
const eTagExisting = sessionStorage.getItem(eTagLocalStore);
const storedData = sessionStorage.getItem(storeId);
// TODO type ConfigType = 'ALL';

export const getConfiguration = async (
  caasUrl,
  configServiceUrl,
  project,
  instance,
  stage,
  language,
  locale,
  masterLocale,
  masterProject,
  type,
  prefix,
) => {
  const localeLowerCase = (locale || language)?.toLowerCase();

  const url = new URL(configServiceUrl, caasUrl)
    .toString()
    .replace('{#project}', project)
    .replace('{#instance}', instance)
    .replace('{#stage}', stage)
    .replace('{#locale}', localeLowerCase)
    .replace('{#masterLocale}', masterLocale)
    .replace('{#masterProject}', masterProject)
    .replace('{#type}', type || 'ALL')
    .replace('{#prefix}', prefix || '');

  try {
    if (eTagExisting) {
      const response = await fetch(url, {
        headers: {
          'If-None-Match': eTagExisting,
        },
        credentials: 'include',
      });
      if (response.status === 304) {
        if (storedData) {
          configData.value = JSON.parse(storedData);
        } else {
          const newResponse = await dataFetch(url);

          if (newResponse.data) {
            sessionStorage.setItem(storeId, JSON.stringify(newResponse.data));
          }
          console.debug(
            `${configServiceUrl} >>> eTag unchanged, data fetched due to lack of SessionStorage entry`,
            configData.value,
          );
        }
      } else {
        const eTag = response.headers.get('Etag');

        if (!response.ok) {
          throw new Error(`${configServiceUrl} >>> error, ${response.status}`);
        }

        if (eTag) {
          sessionStorage.setItem(eTagLocalStore, eTag);
        }

        configData.value = await response.json();
        if (configData.value && Object.keys(configData.value).length) {
          sessionStorage.setItem(storeId, JSON.stringify(configData.value));
        }
        console.debug(`${configServiceUrl} >>> initialized`, configData.value);
      }
    } else {
      const { data, eTag } = await dataFetch(url);

      if (eTag) {
        sessionStorage.setItem(eTagLocalStore, eTag);
      }

      configData.value = data;
      sessionStorage.setItem(storeId, JSON.stringify(configData.value));
    }

    sessionStorage.setItem(storeLocale, JSON.stringify(localeLowerCase));
    sessionStorage.setItem(storeLanguage, JSON.stringify(language?.toLowerCase()));

    return configData.value;
  } catch (error) {
    console.error(`${configServiceUrl} >>> error`, error);
  }
};
